module.exports = __webpack_public_path__ + "static/sidepanel-1x-3d5e15de399bad72775e657605eeacf5.png";